import type { PepLocale } from "../../i18n/types";
import {
  localizeOutcome,
  type ProductOutcomeItem,
} from "./product-detail-types";

interface ProductOutcomesGridProps {
  locale: PepLocale;
  items: ProductOutcomeItem[];
  lead?: string;
  title?: string;
}

export function ProductOutcomesGrid({
  locale,
  items,
  lead,
  title,
}: ProductOutcomesGridProps) {
  if (!items.length) return null;

  const heading =
    title ?? (locale === "en" ? "Concrete results" : "Des résultats concrets");
  const leadText =
    lead ??
    (locale === "en"
      ? "Practical benefits for day-to-day operations."
      : "Des bénéfices concrets pour le quotidien.");

  return (
    <section className="pep-pd-section" aria-labelledby="pep-pd-outcomes-title">
      <div className="container">
        <h2 id="pep-pd-outcomes-title" className="pep-pd-section__title">
          {heading}
        </h2>
        <p className="pep-pd-section__lead">{leadText}</p>
        <div className="pep-pd-outcomes">
          {items.map((item) => {
            const { title: t, body } = localizeOutcome(item, locale);
            return (
              <article key={item.id} className="pep-pd-outcome">
                <span className="pep-pd-outcome__icon" aria-hidden>
                  {item.icon}
                </span>
                <h3 className="pep-pd-outcome__title">{t}</h3>
                <p className="pep-pd-outcome__body">{body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
